module.exports = __webpack_public_path__ + "static/adjustable-base-2-video-cc31ecaf6ba730328253d9b4dd946f7e.mp4";